module.exports = __webpack_public_path__ + "images/search.svg?fe7ee78a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.svg
// module id = 714
// module chunks = 7